// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"c7ab636e","170":"69f077b8","239":"adc31225","462":"2a04c390","818":"cf6c2fad"}[chunkId] + ".chunk.js";
};